import Swal from 'sweetalert2';

const customSwal = Swal.mixin({
  reverseButtons: true,
  confirmButtonColor: '#fbc119', // Cor do botão de confirmação
  cancelButtonColor: '#9b9b9b', // Cor do botão de cancelamento
});

export { customSwal };
